import { render } from "./app-form-info.vue?vue&type=template&id=309dc8cf"
import script from "./app-form-info.vue?vue&type=script&lang=js"
export * from "./app-form-info.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/app-form-info.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "309dc8cf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('309dc8cf', __exports__)) {
    console.log('reload')
    api.reload('309dc8cf', __exports__)
  }
  
  module.hot.accept("./app-form-info.vue?vue&type=template&id=309dc8cf", () => {
    console.log('re-render')
    api.rerender('309dc8cf', render)
  })

}


export default __exports__